<script setup>
  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    items: Array,
    enableAutoplay: Boolean,
    timeAutoplay: [Number, String],
    speed: [Number, String],
  });
</script>
<template>
  <section class="hero-container" v-if="items.length > 0">
    <SfBanerCarousel :items :enableAutoplay :timeAutoplay :speed />
  </section>
</template>
<style lang="scss">
  .hero-container {
    --sf-carousel-slide-padding-x: 0;
    --sf-carousel-slide-padding-y: 0;
    --sf-carousel-button-space: 0.625rem;
    padding-top: 2rem;
  }

  @media(max-width: 992px) {
    .hero-container {
      padding: 0;
    }
  }
</style>
